import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';

interface AlertData {
    type?: string;
    msg: string;
}

interface AlertMsgProps {
    openSnackbar: boolean;
    onClose: (isSubmitted: boolean) => void;
    alertdata?: AlertData;
}

const AlertMsg: React.FC<AlertMsgProps> = ({ openSnackbar, onClose, alertdata }) => {
    const [open, setOpen] = useState<boolean>(openSnackbar);

    useEffect(() => {
        setOpen(openSnackbar);
    }, [openSnackbar]);

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        onClose(false);
    };

    return (
        <div className='alert-popup'>
            <Snackbar
            open={open}
            autoHideDuration={2000} // Adjust duration as needed
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            key="top-center"
        >
            <Alert
                severity={alertdata?.type ? 'success' : 'error'}
                variant="filled"
            >
                {alertdata?.msg}
            </Alert>
        </Snackbar>
        </div>
    );
};

export default AlertMsg;
